module.exports = __webpack_public_path__ + "img/snowflake.3b1761cd.png";